// The 5-bar icon from "Pulse Logo Sheet.png" (public/), reproduced as SVG rather than cropped from
// the flattened sheet so it stays crisp at any size and can recolor per spec's "usage on dark
// background" variant. Geometry/colors are the sheet's exact values (symmetrical 40-70-100-70-40).
const BARS = [
  { x: 3, h: 32, fill: '#003F60' },
  { x: 25, h: 56, fill: '#006B8D' },
  { x: 47, h: 80, fill: '#3093B1' },
  { x: 69, h: 56, fill: '#007C64' },
  { x: 91, h: 32, fill: '#FBB040' },
];

// `trim` adds a thin white outline around each bar — for the header lockup, where the bars sit
// directly on the same navy as one of the darker bar colors (Bar 1) and would otherwise blend in.
export default function PulseMark({ size = 24, monochrome, trim }) {
  return (
    <svg width={size} height={size * (100 / 110)} viewBox="0 0 110 100" aria-hidden focusable="false">
      {BARS.map((bar) => (
        <rect
          key={bar.x}
          x={bar.x}
          y={50 - bar.h / 2}
          width={14}
          height={bar.h}
          rx={7}
          fill={monochrome || bar.fill}
          stroke={trim ? '#ffffff' : 'none'}
          strokeWidth={trim ? 1.5 : 0}
        />
      ))}
    </svg>
  );
}
